import {
  Box,
  Button,
  Card,
  Container,
  Stack,
  Text,
  Title,
  Divider,
  ScrollArea,
  ActionIcon,
  Group,
  useMantineColorScheme,
} from "@mantine/core";
import { ArrowLeft } from "@phosphor-icons/react";


export default function Eula() {
  const { colorScheme } = useMantineColorScheme();
  const textColor = colorScheme === "dark" ? "white" : "#393939";
  const headingColor = colorScheme === "dark" ? "white" : "#1D1D1D";

  return (
    <Box
      style={{
        minHeight: "100vh",
        background: `
        linear-gradient(0deg, #FAFAFA, #FAFAFA),
        linear-gradient(118.69deg, rgba(254, 136, 112, 0.075) 7.78%, rgba(157, 113, 132, 0.075) 50.78%, rgba(45, 86, 154, 0.075) 100%)
        `,
        padding: "24px 0",
      }}
    >
      <Container size="lg">
        <Stack align="center" gap={24}>
          {/* Logo */}
          <Box
            style={{
              width: 183,
              height: 40,
              background: "url(/assets/logo_main.png)",
              backgroundSize: "contain",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          />

          {/* Main Content Card */}
          <Card
            shadow="sm"
            radius="md"
            style={{
              width: "100%",
              maxWidth: 821,
              backgroundColor: "#FFFFFF",
              boxShadow:
                "0px 1px 4px 0px rgba(12, 12, 13, 0.05), 0px 1px 4px 0px rgba(12, 12, 13, 0.1)",
            }}
            p={0}
          >
            <Stack gap={16} p="24px 40px 0">
              <Group justify="space-between" align="center" style={{ position: "relative", minHeight: 40 }}>
                <ActionIcon
                  size="lg"
                  variant="filled"
                  radius="md"
                  style={{
                    backgroundColor: "#FFFFFF",
                          color: headingColor,
                    boxShadow:
                      "0px 1px 4px 0px rgba(12, 12, 13, 0.05), 0px 1px 4px 0px rgba(12, 12, 13, 0.1)",
                    zIndex: 10,
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                  }}
                  styles={{
                    root: {
                      "&:hover": {
                        backgroundColor: "#1D1D1D",
                        color: "#FFFFFF",
                      },
                    },
                  }}
                  onClick={() => window.close()}
                >
                  <ArrowLeft size={18} />
                </ActionIcon>
                <Title
                  order={2}
                  style={{
                    fontFamily: "SF Pro",
                    fontWeight: 510,
                    fontSize: 20,
                    lineHeight: "1.2em",
                    textAlign: "center",
                    color: "#124B8C",
                    position: "absolute",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "100%",
                    pointerEvents: "none",
                  }}
                >
                  End-User License Agreement
                </Title>
                <Box style={{ width: 40 }} />
              </Group>

              {/* Content */}
              <ScrollArea style={{ height: "calc(100vh - 200px)" }}>
                <Stack gap={24} style={{ paddingRight: "16px" }}>
                  {/* Introduction */}
                  <Stack gap={16}>
                    <Box style={{ display: "flex", alignItems: "center", gap: 4 }}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.2em",
                          color: "#979797",
                        }}
                      >
                        Last updated:
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 510,
                          fontSize: 14,
                          lineHeight: "1.2em",
                          color: textColor,
                        }}
                      >
                        January 27, 2021
                      </Text>
                    </Box>
                    <Text
                      style={{
                        fontFamily: "SF Pro",
                        fontSize: 14,
                        lineHeight: "1.4em",
                        color: textColor,
                      }}
                    >
                      Please read this End-User License Agreement carefully before clicking the "I Agree" button, downloading or using Virtual Me.
                    </Text>
                  </Stack>

                  <Divider color="#E9E9E9" />

                  {/* Interpretation and Definitions */}
                  <Stack gap={16}>
                    <Title
                      order={3}
                      style={{
                        fontFamily: "SF Pro",
                        fontWeight: 400,
                        fontSize: 16,
                        lineHeight: "1.3em",
                        color: headingColor,
                      }}
                    >
                      Interpretation and Definitions
                    </Title>

                    <Stack gap={12}>
                      <Title
                        order={4}
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: "1.3em",
                          color: textColor,
                        }}
                      >
                        Interpretation
                      </Title>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
                      </Text>
                    </Stack>

                    <Stack gap={12}>
                      <Title
                        order={4}
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: "1.3em",
                          color: textColor,
                        }}
                      >
                        Definitions
                      </Title>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        For the purposes of this End-User License Agreement:
                      </Text>
                      <Stack gap={8}>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontSize: 14,
                            lineHeight: "1.4em",
                            color: textColor,
                          }}
                        >
                          * Agreement means this End-User License Agreement that forms the entire agreement between You and the Company regarding the use of the Application.
                        </Text>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontSize: 14,
                            lineHeight: "1.4em",
                            color: textColor,
                          }}
                        >
                          * Application means the software program provided by the Company downloaded by You through an Application Store's account to a Device, named Virtual Me
                        </Text>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontSize: 14,
                            lineHeight: "1.4em",
                            color: textColor,
                          }}
                        >
                          * Application Store means the digital distribution service operated and developed by Apple Inc. (Apple App Store) or Google Inc. (Google Play Store) by which the Application has been downloaded to your Device.
                        </Text>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontSize: 14,
                            lineHeight: "1.4em",
                            color: textColor,
                          }}
                        >
                          * Company (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to OneSelf LLC, 14355 McKenna Road NW, Prior Lake, MN, 55372.
                        </Text>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontSize: 14,
                            lineHeight: "1.4em",
                            color: textColor,
                          }}
                        >
                          * Content refers to content such as text, images, or other information that can be posted, uploaded, linked to or otherwise made available by You, regardless of the form of that content.
                        </Text>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontSize: 14,
                            lineHeight: "1.4em",
                            color: textColor,
                          }}
                        >
                          * Country refers to: Minnesota, United States
                        </Text>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontSize: 14,
                            lineHeight: "1.4em",
                            color: textColor,
                          }}
                        >
                          * Device means any device that can access the Application such as a computer, a cellphone or a digital tablet.
                        </Text>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontSize: 14,
                            lineHeight: "1.4em",
                            color: textColor,
                          }}
                        >
                          * Family Sharing / Family Group permits You to share applications downloaded through the Application Store with other family members by allowing them to view and download each others' eligible Applications to their associated Devices.
                        </Text>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontSize: 14,
                            lineHeight: "1.4em",
                            color: textColor,
                          }}
                        >
                          * Third-Party Services means any services or content (including data, information, applications and other products services) provided by a third-party that may be displayed, included or made available by the Application.
                        </Text>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontSize: 14,
                            lineHeight: "1.4em",
                            color: textColor,
                          }}
                        >
                          * You means the individual accessing or using the Application or the company, or other legal entity on behalf of which such individual is accessing or using the Application, as applicable.
                        </Text>
                      </Stack>
                    </Stack>
                  </Stack>

                  <Divider color="#E9E9E9" />

                  {/* Acknowledgment */}
                  <Stack gap={16}>
                    <Title
                      order={3}
                      style={{
                        fontFamily: "SF Pro",
                        fontWeight: 400,
                        fontSize: 16,
                        lineHeight: "1.3em",
                        color: headingColor,
                      }}
                    >
                      Acknowledgment
                    </Title>
                    <Stack gap={12}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        By clicking the "I Agree" button, downloading or using the Application, You are agreeing to be bound by the terms and conditions of this Agreement. If You do not agree to the terms of this Agreement, do not click on the "I Agree" button, do not download or do not use the Application.
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        This Agreement is a legal document between You and the Company and it governs your use of the Application made available to You by the Company.
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        This Agreement is between You and the Company only and not with the Application Store. Therefore, the Company is solely responsible for the Application and its content. Although the Application Store is not a party to this Agreement, it has the right to enforce it against You as a third party beneficiary relating to your use of the Application.
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        Since the Application can be accessed and used by other users via, for example, Family Sharing / Family Group or volume purchasing, the use of the Application by those users is expressly subject to this Agreement.
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        The Application is licensed, not sold, to You by the Company for use strictly in accordance with the terms of this Agreement.
                      </Text>
                    </Stack>
                  </Stack>

                  <Divider color="#E9E9E9" />

                  {/* License */}
                  <Stack gap={16}>
                    <Title
                      order={3}
                      style={{
                        fontFamily: "SF Pro",
                        fontWeight: 400,
                        fontSize: 16,
                        lineHeight: "1.3em",
                        color: headingColor,
                      }}
                    >
                      License
                    </Title>

                    <Stack gap={12}>
                      <Title
                        order={4}
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: "1.3em",
                          color: textColor,
                        }}
                      >
                        Scope of License
                      </Title>
                      <Stack gap={8}>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontSize: 14,
                            lineHeight: "1.4em",
                            color: textColor,
                          }}
                        >
                          The Company grants You a revocable, non-exclusive, non-transferable, limited license to download, install and use the Application strictly in accordance with the terms of this Agreement.
                        </Text>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontSize: 14,
                            lineHeight: "1.4em",
                            color: textColor,
                          }}
                        >
                          You may only use the Application on a Device that You own or control and as permitted by the Application Store's terms and conditions.
                        </Text>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontSize: 14,
                            lineHeight: "1.4em",
                            color: textColor,
                          }}
                        >
                          The license that is granted to You by the Company is solely for your personal, non-commercial purposes strictly in accordance with the terms of this Agreement.
                        </Text>
                      </Stack>
                    </Stack>

                    <Stack gap={12}>
                      <Title
                        order={4}
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: "1.3em",
                          color: textColor,
                        }}
                      >
                        License Restrictions
                      </Title>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        You agree not to, and You will not permit others to:
                      </Text>
                      <Stack gap={8}>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontSize: 14,
                            lineHeight: "1.4em",
                            color: textColor,
                          }}
                        >
                          * License, sell, rent, lease, assign, distribute, transmit, host, outsource, disclose or otherwise commercially exploit the Application or make the Application available to any third party.
                        </Text>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontSize: 14,
                            lineHeight: "1.4em",
                            color: textColor,
                          }}
                        >
                          * Copy or use the Application for any purpose other than as permitted under the above section 'License'.
                        </Text>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontSize: 14,
                            lineHeight: "1.4em",
                            color: textColor,
                          }}
                        >
                          * Modify, make derivative works of, disassemble, decrypt, reverse compile or reverse engineer any part of the Application.
                        </Text>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontSize: 14,
                            lineHeight: "1.4em",
                            color: textColor,
                          }}
                        >
                          * Remove, alter or obscure any proprietary notice (including any notice of copyright or trademark) of the Company or its affiliates, partners, suppliers or the licensors of the Application.
                        </Text>
                      </Stack>
                    </Stack>
                  </Stack>

                  <Divider color="#E9E9E9" />

                  {/* Intellectual Property */}
                  <Stack gap={16}>
                    <Title
                      order={3}
                      style={{
                        fontFamily: "SF Pro",
                        fontWeight: 400,
                        fontSize: 16,
                        lineHeight: "1.3em",
                        color: headingColor,
                      }}
                    >
                      Intellectual Property
                    </Title>
                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        The Application, including without limitation all copyrights, patents, trademarks, trade secrets and other intellectual property rights are, and shall remain, the sole and exclusive property of the Company.
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        The Company shall not be obligated to indemnify or defend You with respect to any third party claim arising out of or relating to the Application. To the extend the Company is required to provide indemnification by applicable law, the Company, not the Application Store, shall be solely responsible for the investigation, defense, settlement and discharge of any claim that the Application or your use of it infringes any third party intellectual property rights.
                      </Text>
                    </Stack>
                  </Stack>

                  <Divider color="#E9E9E9" />

                  {/* Modifications to the Application */}
                  <Stack gap={16}>
                    <Title
                      order={3}
                      style={{
                        fontFamily: "SF Pro",
                        fontWeight: 400,
                        fontSize: 16,
                        lineHeight: "1.3em",
                        color: headingColor,
                      }}
                    >
                      Modifications to the Application
                    </Title>
                    <Text
                      style={{
                        fontFamily: "SF Pro",
                        fontSize: 14,
                        lineHeight: "1.4em",
                        color: textColor,
                      }}
                    >
                      The Company reserves the right to modify, suspend or discontinue, temporarily or permanently, the Application or any service to which it connects, with or without notice and without liability to You.
                    </Text>

                    <Stack gap={12}>
                      <Title
                        order={4}
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: "1.3em",
                          color: textColor,
                        }}
                      >
                        Updates to the Application
                      </Title>
                      <Stack gap={8}>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontSize: 14,
                            lineHeight: "1.4em",
                            color: textColor,
                          }}
                        >
                          The Company may from time to time provide enhancements or improvements to the features/functionality of the Application, which may include patches, bug fixes, updates, upgrades and other modifications.
                        </Text>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontSize: 14,
                            lineHeight: "1.4em",
                            color: textColor,
                          }}
                        >
                          Updates may modify or delete certain features and/or functionalities of the Application. You agree that the Company has no obligation to (i) provide any Updates, or (ii) continue to provide or enable any particular features and/or functionalities of the Application to You.
                        </Text>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontSize: 14,
                            lineHeight: "1.4em",
                            color: textColor,
                          }}
                        >
                          You further agree that all updates or any other modifications will be (i) deemed to constitute an integral part of the Application, and (ii) subject to the terms and conditions of this Agreement.
                        </Text>
                      </Stack>
                    </Stack>
                  </Stack>

                  <Divider color="#E9E9E9" />

                  {/* Maintenance and Support */}
                  <Stack gap={16}>
                    <Title
                      order={3}
                      style={{
                        fontFamily: "SF Pro",
                        fontWeight: 400,
                        fontSize: 16,
                        lineHeight: "1.3em",
                        color: headingColor,
                      }}
                    >
                      Maintenance and Support
                    </Title>
                    <Text
                      style={{
                        fontFamily: "SF Pro",
                        fontSize: 14,
                        lineHeight: "1.4em",
                        color: textColor,
                      }}
                    >
                      The Company does not provide any maintenance or support for the download and use of the Application. To the extent that any maintenance or support is required by applicable law, the Company, not the Application Store, shall be obligated to furnish any such maintenance or support.
                    </Text>
                  </Stack>

                  <Divider color="#E9E9E9" />

                  {/* Third-Party Services */}
                  <Stack gap={16}>
                    <Title
                      order={3}
                      style={{
                        fontFamily: "SF Pro",
                        fontWeight: 400,
                        fontSize: 16,
                        lineHeight: "1.3em",
                        color: headingColor,
                      }}
                    >
                      Third-Party Services
                    </Title>
                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        The Application may display, include or make available third-party content (including data, information, applications and other products services) or provide links to third-party websites or services.
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        You acknowledge and agree that the Company shall not be responsible for any Third-party Services, including their accuracy, completeness, timeliness, validity, copyright compliance, legality, decency, quality or any other aspect thereof. The Company does not assume and shall not have any liability or responsibility to You or any other person or entity for any Third-party Services.
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        You must comply with applicable Third parties' Terms of agreement when using the Application. Third-party Services and links thereto are provided solely as a convenience to You and You access and use them entirely at your own risk and subject to such third parties' Terms and conditions.
                      </Text>
                    </Stack>
                  </Stack>

                  <Divider color="#E9E9E9" />

                  {/* Privacy Policy */}
                  <Stack gap={16}>
                    <Title
                      order={3}
                      style={{
                        fontFamily: "SF Pro",
                        fontWeight: 400,
                        fontSize: 16,
                        lineHeight: "1.3em",
                        color: headingColor,
                      }}
                    >
                      Privacy Policy
                    </Title>
                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        The Company collects, stores, maintains, and shares information about You in accordance with Our Privacy Policy: https://www.privacypolicies.com/live/b6480410-fe05-4772-8db6-762e835ebaa3
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        By accepting this Agreement, You acknowledge that You hereby agree and consent to the terms and conditions of Our Privacy Policy.
                      </Text>
                    </Stack>
                  </Stack>

                  <Divider color="#E9E9E9" />

                  {/* Term and Termination */}
                  <Stack gap={16}>
                    <Title
                      order={3}
                      style={{
                        fontFamily: "SF Pro",
                        fontWeight: 400,
                        fontSize: 16,
                        lineHeight: "1.3em",
                        color: headingColor,
                      }}
                    >
                      Term and Termination
                    </Title>
                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        This Agreement shall remain in effect until terminated by You or the Company. The Company may, in its sole discretion, at any time and for any or no reason, suspend or terminate this Agreement with or without prior notice.
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        This Agreement will terminate immediately, without prior notice from the Company, in the event that you fail to comply with any provision of this Agreement. You may also terminate this Agreement by deleting the Application and all copies thereof from your Device or from your computer.
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        Upon termination of this Agreement, You shall cease all use of the Application and delete all copies of the Application from your Device.
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        Termination of this Agreement will not limit any of the Company's rights or remedies at law or in equity in case of breach by You (during the term of this Agreement) of any of your obligations under the present Agreement.
                      </Text>
                    </Stack>
                  </Stack>

                  <Divider color="#E9E9E9" />

                  {/* Indemnification */}
                  <Stack gap={16}>
                    <Title
                      order={3}
                      style={{
                        fontFamily: "SF Pro",
                        fontWeight: 400,
                        fontSize: 16,
                        lineHeight: "1.3em",
                        color: headingColor,
                      }}
                    >
                      Indemnification
                    </Title>
                    <Text
                      style={{
                        fontFamily: "SF Pro",
                        fontSize: 14,
                        lineHeight: "1.4em",
                        color: textColor,
                      }}
                    >
                      You agree to indemnify and hold the Company and its parents, subsidiaries, affiliates, officers, employees, agents, partners and licensors (if any) harmless from any claim or demand, including reasonable attorneys' fees, due to or arising out of your: (a) use of the Application; (b) violation of this Agreement or any law or regulation; or (c) violation of any right of a third party.
                    </Text>
                  </Stack>

                  <Divider color="#E9E9E9" />

                  {/* No Warranties */}
                  <Stack gap={16}>
                    <Title
                      order={3}
                      style={{
                        fontFamily: "SF Pro",
                        fontWeight: 400,
                        fontSize: 16,
                        lineHeight: "1.3em",
                        color: headingColor,
                      }}
                    >
                      No Warranties
                    </Title>
                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        The Application is provided to You "AS IS" and "AS AVAILABLE" and with all faults and defects without warranty of any kind. To the maximum extent permitted under applicable law, the Company, on its own behalf and on behalf of its affiliates and its and their respective licensors and service providers, expressly disclaims all warranties, whether express, implied, statutory or otherwise, with respect to the Application, including all implied warranties of merchantability, fitness for a particular purpose, title and non-infringement, and warranties that may arise out of course of dealing, course of performance, usage or trade practice. Without limitation to the foregoing, the Company provides no warranty or undertaking, and makes no representation of any kind that the Application will meet your requirements, achieve any intended results, be compatible or work with any other software, applications, systems or services, operate without interruption, meet any performance or reliability standards or be error free or that any errors or defects can or will be corrected.
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        Without limiting the foregoing, neither the Company nor any of the company's provider makes any representation or warranty of any kind, express or implied: (i) as to the operation or availability of the Application, or the information, content, and materials or products included thereon; (ii) that the Application will be uninterrupted or error-free; (iii) as to the accuracy, reliability, or currency of any information or content provided through the Application; or (iv) that the Application, its servers, the content, or e-mails sent from or on behalf of the Company are free of viruses, scripts, trojan horses, worms, malware, timebombs or other harmful components.
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        Some jurisdictions do not allow the exclusion of certain types of warranties or limitations on applicable statutory rights of a consumer, so some or all of the above exclusions and limitations may not apply to You. But in such a case the exclusions and limitations set forth in this section 11 shall be applied to the greatest extent enforceable under applicable law. To the extent any warranty exists under law that cannot be disclaimed, the Company, not the Application Store, shall be solely responsible for such warranty.
                      </Text>
                    </Stack>
                  </Stack>

                  <Divider color="#E9E9E9" />

                  {/* Limitation of Liability */}
                  <Stack gap={16}>
                    <Title
                      order={3}
                      style={{
                        fontFamily: "SF Pro",
                        fontWeight: 400,
                        fontSize: 16,
                        lineHeight: "1.3em",
                        color: headingColor,
                      }}
                    >
                      Limitation of Liability
                    </Title>
                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        Notwithstanding any damages that You might incur, the entire liability of the Company and any of its suppliers under any provision of this Agreement and your exclusive remedy for all of the foregoing shall be limited to the amount actually paid by You for the Application or through the Application.
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        To the maximum extent permitted by applicable law, in no event shall the Company or its suppliers be liable for any special, incidental, indirect, or consequential damages whatsoever (including, but not limited to, damages for loss of profits, loss of data or other information, for business interruption, for personal injury, loss of privacy arising out of or in any way related to the use of or inability to use the Application, third-party software and/or third-party hardware used with the Application, or otherwise in connection with any provision of this Agreement), even if the Company or any supplier has been advised of the possibility of such damages and even if the remedy fails of its essential purpose.
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        Some states/jurisdictions do not allow the exclusion or limitation of incidental or consequential damages, so the above limitation or exclusion may not apply to You.
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        You expressly understand and agree that the Application Store, its subsidiaries and affiliates, and its licensors shall not be liable to You under any theory of liability for any direct, indirect, incidental, special consequential or exemplary damages that may be incurred by You, including any loss of data, whether or not the Application Store or its representatives have been advised of or should have been aware of the possibility of any such losses arising.
                      </Text>
                    </Stack>
                  </Stack>

                  <Divider color="#E9E9E9" />

                  {/* Severability and Waiver */}
                  <Stack gap={16}>
                    <Title
                      order={3}
                      style={{
                        fontFamily: "SF Pro",
                        fontWeight: 400,
                        fontSize: 16,
                        lineHeight: "1.3em",
                        color: headingColor,
                      }}
                    >
                      Severability and Waiver
                    </Title>

                    <Stack gap={12}>
                      <Title
                        order={4}
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: "1.3em",
                          color: textColor,
                        }}
                      >
                        Severability
                      </Title>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        If any provision of this Agreement is held to be unenforceable or invalid, such provision will be changed and interpreted to accomplish the objectives of such provision to the greatest extent possible under applicable law and the remaining provisions will continue in full force and effect.
                      </Text>
                    </Stack>

                    <Stack gap={12}>
                      <Title
                        order={4}
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: "1.3em",
                          color: textColor,
                        }}
                      >
                        Waiver
                      </Title>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        Except as provided herein, the failure to exercise a right or to require performance of an obligation under this Agreement shall not effect a party's ability to exercise such right or require such performance at any time thereafter nor shall be the waiver of a breach constitute a waiver of any subsequent breach.
                      </Text>
                    </Stack>
                  </Stack>

                  <Divider color="#E9E9E9" />

                  {/* Product Claims */}
                  <Stack gap={16}>
                    <Title
                      order={3}
                      style={{
                        fontFamily: "SF Pro",
                        fontWeight: 400,
                        fontSize: 16,
                        lineHeight: "1.3em",
                        color: headingColor,
                      }}
                    >
                      Product Claims
                    </Title>
                    <Text
                      style={{
                        fontFamily: "SF Pro",
                        fontSize: 14,
                        lineHeight: "1.4em",
                        color: textColor,
                      }}
                    >
                      The Company does not make any warranties concerning the Application. To the extent You have any claim arising from or relating to your use of the Application, the Company, not the Application Store, is responsible for addressing any such claims, which may include, but not limited to: (i) any product liability claims; (ii) any claim that the Application fails to conform to any applicable legal or regulatory requirement; and (iii) any claim arising under consumer protection, or similar legislation.
                    </Text>
                  </Stack>

                  <Divider color="#E9E9E9" />

                  {/* United States Legal Compliance */}
                  <Stack gap={16}>
                    <Title
                      order={3}
                      style={{
                        fontFamily: "SF Pro",
                        fontWeight: 400,
                        fontSize: 16,
                        lineHeight: "1.3em",
                        color: headingColor,
                      }}
                    >
                      United States Legal Compliance
                    </Title>
                    <Text
                      style={{
                        fontFamily: "SF Pro",
                        fontSize: 14,
                        lineHeight: "1.4em",
                        color: textColor,
                      }}
                    >
                      You represent and warrant that (i) You are not located in a country that is subject to the United States government embargo, or that has been designated by the United States government as a "terrorist supporting" country, and (ii) You are not listed on any United States government list of prohibited or restricted parties.
                    </Text>
                  </Stack>

                  <Divider color="#E9E9E9" />

                  {/* Changes to this Agreement */}
                  <Stack gap={16}>
                    <Title
                      order={3}
                      style={{
                        fontFamily: "SF Pro",
                        fontWeight: 400,
                        fontSize: 16,
                        lineHeight: "1.3em",
                        color: headingColor,
                      }}
                    >
                      Changes to this Agreement
                    </Title>
                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        The Company reserves the right, at its sole discretion, to modify or replace this Agreement at any time. If a revision is material we will provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at the sole discretion of the Company.
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        By continuing to access or use the Application after any revisions become effective, You agree to be bound by the revised terms. If You do not agree to the new terms, You are no longer authorized to use the Application.
                      </Text>
                    </Stack>
                  </Stack>

                  <Divider color="#E9E9E9" />

                  {/* Governing Law */}
                  <Stack gap={16}>
                    <Title
                      order={3}
                      style={{
                        fontFamily: "SF Pro",
                        fontWeight: 400,
                        fontSize: 16,
                        lineHeight: "1.3em",
                        color: headingColor,
                      }}
                    >
                      Governing Law
                    </Title>
                    <Text
                      style={{
                        fontFamily: "SF Pro",
                        fontSize: 14,
                        lineHeight: "1.4em",
                        color: textColor,
                      }}
                    >
                      The laws of the Country, excluding its conflicts of law rules, shall govern this Agreement and your use of the Application. Your use of the Application may also be subject to other local, state, national, or international laws.
                    </Text>
                  </Stack>

                  <Divider color="#E9E9E9" />

                  {/* Entire Agreement */}
                  <Stack gap={16}>
                    <Title
                      order={3}
                      style={{
                        fontFamily: "SF Pro",
                        fontWeight: 400,
                        fontSize: 16,
                        lineHeight: "1.3em",
                        color: headingColor,
                      }}
                    >
                      Entire Agreement
                    </Title>
                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        The Agreement constitutes the entire agreement between You and the Company regarding your use of the Application and supersedes all prior and contemporaneous written or oral agreements between You and the Company.
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontSize: 14,
                          lineHeight: "1.4em",
                          color: textColor,
                        }}
                      >
                        You may be subject to additional terms and conditions that apply when You use or purchase other Company's services, which the Company will provide to You at the time of such use or purchase.
                      </Text>
                    </Stack>
                  </Stack>

                  <Divider color="#E9E9E9" />

                  {/* Contact Us */}
                  <Stack gap={16}>
                    <Title
                      order={3}
                      style={{
                        fontFamily: "SF Pro",
                        fontWeight: 400,
                        fontSize: 16,
                        lineHeight: "1.3em",
                        color: headingColor,
                      }}
                    >
                      Contact Us
                    </Title>
                    <Text
                      style={{
                        fontFamily: "SF Pro",
                        fontSize: 14,
                        lineHeight: "1.4em",
                        color: textColor,
                      }}
                    >
                      If you have any questions about this Agreement, You can contact Us:
                    </Text>
                    <Text
                      style={{
                        fontFamily: "SF Pro",
                        fontSize: 14,
                        lineHeight: "1.4em",
                        color: textColor,
                      }}
                    >
                      * By email: contact@onselftechnology.com
                    </Text>
                  </Stack>

                </Stack>
              </ScrollArea>

              <Box style={{ display: "flex", justifyContent: "flex-start", padding: "24px 40px 24px 0px", marginLeft: "-40px", paddingLeft: "40px" }}>
                <Button
                  size="md"
                  style={{
                    backgroundColor: "#124B8C",
                    color: "white",
                    borderRadius: "8px",
                    padding: "7px 32px",
                    fontWeight: 500,
                    fontSize: "16px",
                    marginLeft: 0,
                  }}
                  onClick={() => {
                    if (window.opener) {
                      window.opener.postMessage({ type: 'AGREE_EULA' }, '*');
                    }
                    window.close();
                  }}
                >
                  I Agree
                </Button>
              </Box>
            </Stack>
          </Card>
        </Stack>
      </Container>
    </Box>
  );
}
